export const groupNames = [
  'AKTIVA',
  'POTRAZIVANJA ZA UPISANI A NEUPLACENI KAPITAL2',
  'DUGOTRAJNA IMOVINA (003+010+020+029+033)',
  'KRATKOTRAJNA IMOVINA (035+043+050+058)',
  'PLACENI TROSKOVI BUDUCEG RAZDOBLJA I OBRACUNATI PRIHODI',
  'UKUPNO AKTIVA (001+002+034+059)',
  'IZVANBILANCNI ZAPISI',
  'PASIVA',
  'KAPITAL I REZERVE (063+064+065+071+072+075+078)',
  'TEMELJNI (UPISANI) KAPITAL',
  'KAPITALNE REZERVE',
  'REZERVE IZ DOBITI (066+067-068+069+070)',
  'Rezerve za vlastite dionice',
  'Zakonske rezerve',
  'Vlastite dionice i udjeli (odbitna stavka)',
  'Statutarne rezerve',
  'Ostale rezerve',
  'REVALORIZACIJSKE REZERVE',
  'ZADRZANA DOBIT ILI PRENESENI GUBITAK (073-074)',
  'Zadržana dobit',
  'Preneseni gubitak',
  'NETO DOBIT ILI GUBITAK POSLOVNE GODINE (076-077)',
  'BRUTO DOBIT ILI GUBITAK POSLOVNE GODINE',
  'POSLOVNI PRIHODI (112+113)',
  'Prihodi od prodaje',
  'Prihodi od prodaje novih vozila',
  'VW Osobni',
  'Skoda',
  'VW Gospodarski',
  'Popusti',
  'Prihodi od prodaje rabljenih vozila',
  'Prihodi - nepovezani',
  'Prihodi - povezani',
  'Prihodi od prodaje rez. djelova i ugradnje',
  'Prihodi od rez. djelova i ugradnje',
  'Popusti',
  'Prihodi od prodaje u servisu',
  'Ostali poslovni prihodi',
  'Prihod od najma',
  'Prihod od prodaje materijalne imovine',
  'Prihodi od naknadno odobrenih popusta',
  'Prihodi od naknadno naplacenih potrazivanja',
  'Inventurni viskovi',
  'Prihodi od naplate stete',
  'Prihod od ukidanja rezerviranja',
  'Prihod od odobrenja',
  'Ostalo',
  'POSLOVNI RASHODI (115+116+120+124+125+126+129+130)',
  'Promjene vrijednosti zaliha proizvodnje u tijeku i gotovih proizvoda',
  'Materijalni troškovi (117 do 119)',
  'Troškovi sirovina i materijala',
  'Utrošeni materijal',
  'Potroseno gorivo i energija',
  'Trosak rezervnih dijelova',
  'Trosak sitnog inventarra, ambalaze i auto-guma',
  'Troškovi prodane robe',
  'Nabavna vrijednost novih vozila',
  'Nabavna vrijednost rabljenih vozila',
  'nabavna vrijednost rezervnih dijelova',
  'Ostali vanjski troškovi',
  'Prijevozne i telekomunikacijske usluge',
  'Troskove tekuceg odrzavanja',
  'Usluge zakupa',
  'Usluge promidzbe',
  'Komunalne usluge',
  'Usluge elektronicke obrade podataka',
  'Intelektualne i osobne usluge',
  'Ostale usluge',
  'Troškovi osoblja (121 do 123)',
  'Neto place i nadoknade',
  'Troskovi poreza i doprinosa',
  'Doprinosi na place',
  'Amortizacija',
  'Ostali troškovi',
  'Naknade zaposlenicima',
  'Reprezentacija i izuzimanja trgovaèke robe',
  'Premije osiguranja',
  'Bankarske usluge',
  'Porezi i doprinosi koji je ovise o rezultatu',
  'Ostali troškovi poslovanja',
  'Vrijednosno uskladjivanje (127+128)',
  'Dugotrajne imovine (osim financijske imovine)',
  'Vrijednosno uskladjenje materijalne imovine',
  'Vrijednosno uskladjenje nematerijalne imovine',
  'Kratkotrajne imovine (osim financijske imovine)',
  'Rezerviranja',
  'Ostali poslovni rashodi',
  'Otpis vrijednosno neusklaðenih potraživanja',
  'Otpis zastarijelih zaliha',
  'Troskovi kala, rastepa i kvara',
  'Kazne penali i nadoknade šteta',
  'Naknadno utvrðeni troškovi poslovanja',
  'Ostali poslovni rashodi',
  'FINANCIJSKI PRIHODI (132 do 136)',
  'Kamate, tecajne razlike, dividende i slicni prihodi iz odnosa s povezanim poduzetnicima',
  'Prihodi od kamata od povezanih poduzetnika',
  'Prihodi od tecajnih razlika od povezanih poduzetnika',
  'Prihodi od dividende',
  'Kamate, tecajne razlike, dividende, slicni prihodi iz odnosa s nepovezanim poduzetnicima i drugim osobama',
  'Prihodi od kamata od nepovezanih poduzetnika',
  'Prihodi od tecajnih razlika od nepovezanih poduzetnika',
  'Prihodi od dividende',
  'Dio prihoda od pridruženih poduzetnika i sudjelujucih interesa',
  'Nerealizirani dobici (prihodi) od financijske imovine',
  'Ostali financijski prihodi',
  'FINANCIJSKI RASHODI (138 do 141)',
  'Kamate, tecajne razlike i drugi rashodi s povezanim poduzetnicima',
  'Kamate od povezanih drustava',
  'Redovne kamate od povezanih drustava',
  'Zatezne kamate od povezanih drustava',
  'Tecajne razlike iz odnosa s povezanim drustvima',
  'Kamate, tecajne razlike i drugi rashodi iz odnosa s nepovezanim poduzetnicima i drugim osobama',
  'Kamate iz odnosa s nepovezanim drustvima',
  'Redovne kamate iz odnosa s nepovezanim društvima',
  'Zatezne kamate iz odnosa s nepovezanim društvima',
  'Tecajne razlike iz odnosa s povezanim drustvima',
  'Nerealizirani gubici (rashodi) od financijske imovine',
  'Ostali financijski rashodi',
  'UDIO U DOBITI OD PRIDRUŽENIH PODUZETNIKA',
  'UDIO U GUBITKU OD PRIDRUŽENIH PODUZETNIKA',
  'IZVANREDNI - OSTALI PRIHODI',
  'IZVANREDNI - OSTALI RASHODI',
  'UKUPNI PRIHODI (111+131+142 + 144)',
  'UKUPNI RASHODI (114+137+143 + 145)',
  'DOBIT ILI GUBITAK PRIJE OPOREZIVANJA (146-147)',
  'POREZ NA DOBIT',
  'DOBIT ILI GUBITAK RAZDOBLJA (148-151)',
  'MANJINSKI INTERES',
  'REZERVIRANJA',
  'Rezerviranja za mirovine, otpremnine i sliène obveze',
  'Rezerviranja za porezne obveze',
  'Druga rezerviranja',
  'DUGOROCNE OBVEZE',
  'Obveze prema povezanim poduzetnicima',
  'Obveze za zajmove, depozite i slicno',
  'Obveze prema bankama i drugim financijskim institucijama',
  'Obveze za predujmove',
  'Obveze prema dobavljacima',
  'Obveze po vrijednosnim papirima',
  'Obveze prema poduzetnicima u kojima postoje sudjelujući interesi',
  'Ostale dugorocne obveze',
  'Odgodjena porezna obveza',
  'KRATKOROCNE OBVEZE',
  'Obveze prema povezanim poduzetnicima',
  'Obveze za zajmove, depozite i slicno',
  'Obveze prema bankama i drugim financijskim institucijama',
  'Obveze za predujmove',
  'Obveze prema dobavljacima',
  'Obveze po vrijednosnim papirima',
  'Obveze prema poduzetnicima u kojima postoje sudjelujuci interesi',
  'Obveze prema zaposlenicima',
  'Obveze za poreze, doprinose i slicna davanja',
  'Obveze s osnove udjela u rezultatu',
  'Obveze po osnovi dugotrajne imovine namijenjene prodaji',
  'Ostale kratkorocne obveze',
  'ODGODJENO PLACANJE TROSKOVA I PRIHOD BUDUCEG RAZDOBLJA',
  'UKUPNO PASIVA',
  'IZVANBILANCNI ZAPISI',
];
